import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrent(index);
      setTimeout(() => setIsTransitioning(false), 600);
    },
    [isTransitioning],
  );

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="推荐Banner">
      {banners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={b.image}
            alt={b.title}
            className="w-full h-full object-cover object-top"
            loading={i === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50 z-20"></div>

      <div className="absolute inset-0 z-30 flex items-center">
        <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-lg">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 mb-4">
              {banner.badge}
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-display font-bold text-white leading-tight mb-3">
              {banner.title}
            </h1>
            <p className="text-lg md:text-xl text-white/80 font-heading mb-2">
              {banner.subtitle}
            </p>
            <p className="text-sm md:text-base text-white/60 mb-6 line-clamp-2">
              {banner.description}
            </p>
            <Link
              to={`/comic/${banner.comicSlug}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              立即阅读
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === current
                ? 'bg-primary-500 w-6'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`切换到第${i + 1}张Banner`}
          />
        ))}
      </div>
    </section>
  );
}